import { render, staticRenderFns } from "./SongForm.vue?vue&type=template&id=13f1849c&scoped=true&"
import script from "./SongForm.vue?vue&type=script&lang=js&"
export * from "./SongForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f1849c",
  null
  
)

export default component.exports